import { useEffect, useState } from "react";
import { FavoriteArea, FAVORITES_CHANGED_EVENT, getFavorites } from "../utils/favorites";

/// Current favorite areas, updated when they change on this page or in another tab
export function useFavorites(): FavoriteArea[] {
  const [favorites, setFavorites] = useState<FavoriteArea[]>(getFavorites);

  useEffect(() => {
    const update = () => setFavorites(getFavorites());
    window.addEventListener(FAVORITES_CHANGED_EVENT, update);
    window.addEventListener("storage", update);
    return () => {
      window.removeEventListener(FAVORITES_CHANGED_EVENT, update);
      window.removeEventListener("storage", update);
    };
  }, []);

  return favorites;
}
